import styled from 'styled-components'
import LoginScreen from '../../assets/images/Login/LoginImage.svg'

export const Container = styled.div`
  background: linear-gradient(180deg, #0384b9 0%, #150d49 100%);
  height: 100vh;
  width: 100vw;
  display: flex;
  gap: 1rem;
`

export const LoginImage = styled.div`
  height: 100%;
  width: 60%;
  display: flex;
  background-image: url(${LoginScreen});
  background-size: cover;
  background-repeat: no-repeat;
`

export const Content = styled.div`
  height: 100%;
  width: 40%;
  background-color: ${(props) => props.theme.color.neutral.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`

export const MainContent = styled.div`
  height: calc(100% - 20rem);
  width: 55%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;
  top: 0;
  justify-content: center;
`

export const LogoImage = styled.img`
  height: 4.5rem;
  width: auto;
  font-size: ${(props) => props.theme.font.textcaption};
`

export const RadioContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 1rem;
`

export const SubmitContainer = styled.div`
  width: 100%;
`

export const LoginFooter = styled.div`
  height: 2rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.color.blue.blue100};
  position: absolute;
  bottom: 0;
`

export const InputContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.125rem;
  width: 100%;
`

export const Text = styled.p`
  font-size: ${(props) => props.theme.font.textcaption};
  color: ${(props) => props.theme.color.purple.purple900};
  font-weight: 400;
  letter-spacing: 0.003rem;
`

export const FormRadioContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 1rem;
  cursor: pointer;
`

export const RadioInput = styled.input.attrs({ type: 'radio' })`
  appearance: none;
`

interface RadioProps {
  isChecked: boolean
}

export const RadioAppearence = styled.label<RadioProps>`
  min-width: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.color.purple.purple700};
  background: ${(props) =>
    props.isChecked
      ? props.theme.color.purple.purple800
      : props.theme.color.blue.blue50};
  padding: 0.6875rem 1rem;
  color: ${(props) =>
    props.isChecked
      ? props.theme.color.neutral.white
      : props.theme.color.purple.purple800};
  font-size: ${(props) => props.theme.font.textsm};
  font-weight: 500;
  letter-spacing: 0.05rem;
  cursor: pointer;
`

export const ResendCode = styled.div`
  font-size: 0.875rem;
  letter-spacing: 0.01094rem;
  color: ${(props) => props.theme.color.purple.base};
  cursor: pointer;
`
